import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { UrlHelpers } from '../../service/UrlHelpers';
import { LinkTarget } from '../../typings/common';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { MoneyText } from '../MoneyText/MoneyText';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';
import { StyledLink } from '../StyledLink/StyledLink';

import './GridCampaignRestSumCell.css';
import * as keyset from './GridCampaignRestSumCell.i18n';

const i18n = i18nFactory(keyset);

export interface GridCampaignRestSumCellProps {
    value: number;
    needPayment: boolean;
    moneyBlocked: boolean;
    campaignId: string;
    chiefLogin: string;
    canPay: boolean;
}

export class GridCampaignRestSumCell extends React.Component<
    GridCampaignRestSumCellProps
> {
    render() {
        const { needPayment } = this.props;

        return (
            <div className={Bem.cls('grid-campaign-rest-sum-cell')}>
                <div
                    className={Bem.cls({
                        block: 'grid-campaign-rest-sum-cell',
                        elem: 'value',
                        mods: {
                            warning: needPayment
                        }
                    })}
                >
                    {this.getCellContent()}
                </div>
            </div>
        );
    }

    private getCellContent = () => {
        const {
            moneyBlocked,
            needPayment,
            value,
            campaignId,
            chiefLogin,
            canPay
        } = this.props;

        const addMoneyLink = (
            <div>
                <StyledLink
                    cls={Bem.cls('grid-campaign-rest-sum-cell', 'link')}
                    target={LinkTarget.blank}
                    href={UrlHelpers.getPayUrl(campaignId, chiefLogin)}
                >
                    {i18n('addMoney')}
                    <Shape2
                        icon={Shape2Icon.link}
                        theme={Shape2Theme.light}
                        width={10}
                        height={10}
                        cls={Bem.cls(
                            'grid-campaign-rest-sum-cell',
                            'link-icon'
                        )}
                    />
                </StyledLink>
            </div>
        );

        let moneyTextComponent = (
            <MoneyText num={value} fractionalPartLength={2} />
        );

        let hint = null;

        if (moneyBlocked) {
            hint = i18n('moneyBlocked');
        } else if (needPayment) {
            hint = i18n('needPayment');
        }

        if (hint) {
            moneyTextComponent = (
                <HoverTooltipWrapper to={['bottom']} tooltipText={hint}>
                    {moneyTextComponent}
                </HoverTooltipWrapper>
            );
        }

        if (canPay) {
            return (
                <>
                    {moneyTextComponent}
                    {addMoneyLink}
                </>
            );
        } else {
            return moneyTextComponent;
        }
    };
}
